import './Header.css';
import { useState } from 'react';

const Header = ({ navigate }) => {
    
    const [isMenuOpen, setMenuOpen] = useState(false);

    const handleNavigation = (path) => {
        navigate(path); 
    };

    const toggleMenu = () => {
      setMenuOpen(!isMenuOpen);
    };

    return (
        <nav>
             <div className="logo-container">
                <img src="/assets/images/logo_tonycars.png" alt="Logo" className="logo" />
            </div>
            <div className="menu-icon" onClick={toggleMenu}>
                <span>☰</span>
            </div>
            <ul className={`menu ${isMenuOpen ? 'open' : ''}`}>
                <li onClick={() => handleNavigation('/')}>Home</li>
                <li onClick={() => handleNavigation('/catalogo')}>Catalogo</li>
                <li onClick={() => handleNavigation('/contatti')}>Contatti</li>
            </ul>
        </nav>
    );

}

export default Header;